import React, { useEffect, useState } from "react";
import '../../../../assets/css/valuelist.css';
import MainWrapper from "../../../MainWrapper";
import { Link, Navigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { ic_arrow_back, ic_mode_edit, ic_save } from 'react-icons-kit/md';
import { Table, Form, Button, InputGroup } from 'react-bootstrap';
// import { encrypted } from '../../../../_utils/helpers';
import { connect } from 'react-redux';
import Create from "./models/Create";
import ConfirmDelete from "./models/ConfirmDelete";
import {
	MARKET_SECTOR_REQUEST,
	MARKET_SECTOR_CREATE,
	MARKET_SECTOR_DELETE,
	MARKET_SECTOR_EDIT,
	MARKET_SECTOR_STATE_CHANGE
} from "../../../../_utils/constants/ValueList";
import Loader from "../../../layouts/Loader";
import { toast } from 'react-toastify';

const MarketSector = ({
	auth: { auth, isAuthenticated },
	valueList: { valueList, isCreated, isDeleted, isEdited, isLoading },
	fetchMarketSector,
	submitMarketSectorCreate,
	submitMarketSectorDelete,
	submitMarketSectorEdit,
	changeReducerState
}) => {

	// states declarations
	const [createModalOpen, setCreateModalOpen] = useState(false);
	const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
	const [inputVal, setInputVal] = useState('');
	const [deleteMarketSectorId, setDeleteMarketSectorId] = useState('');
	const [editMarketSectorId, setEditMarketSectorId] = useState('');
	const [editMarketSectorName, setEditMarketSectorName] = useState('');

	// use effect function called for authentication
	useEffect(() => {
		if (isAuthenticated) {
			fetchMarketSector(auth[0].token);
		}
	}, [auth, isAuthenticated]);

	// use effect function called after api success
	useEffect(() => {
		if (isCreated === true) {
			toast.success("MarketSector Created Successfully.");
			fetchMarketSector(auth[0].token);
			changeReducerState();
		}
		if (isDeleted === true) {
			toast.success("MarketSector Deleted Successfully.");
			fetchMarketSector(auth[0].token);
			changeReducerState();
		}
		if (isEdited === true) {
			toast.success("MarketSector Data Updated Successfully.");
			fetchMarketSector(auth[0].token);
			changeReducerState();
		}
	}, [isCreated, isDeleted, isEdited]);

	// function to open create modal
	const showCreateModal = () => {
		setCreateModalOpen(true);
	};

	// function to close create modal
	const hideCreateModal = () => {
		setCreateModalOpen(false);
	};

	// function called for input value change of create modal
	const handleCreateModalChange = (e) => {
		setInputVal(e.target.value);
	}

	// function called for create age demographic create api
	const handleCreateModalSubmit = (e) => {
		e.preventDefault();
		if (inputVal === '') {
			toast.error("MarketSector name cannot be empty.");
		} else {
			submitMarketSectorCreate({
				"data": {
					"MarketSectorName": inputVal,
					"CreatedBy": auth[0].userId
				},
				"token": auth[0].token
			});
			hideCreateModal();
		}
	}

	// function to open confirm delete modal
	const showConfirmDeleteModal = (id) => {
		setDeleteMarketSectorId(id);
		setConfirmDeleteModal(true);
	};

	// function to close confirm delete modal
	const hideConfirmDeleteModal = () => {
		setDeleteMarketSectorId('');
		setConfirmDeleteModal(false);
	};

	// function called for delete age demographic delete api
	const handleConfirmDeleteSubmit = () => {
		submitMarketSectorDelete({
			"MarketSectorId": deleteMarketSectorId,
			"token": auth[0].token
		});
		hideConfirmDeleteModal();
	}

	// function called on edit icon click
	const handleEditClick = (data) => {
		setEditMarketSectorId(data.marketSectorId);
		setEditMarketSectorName(data.marketSectorName);
	}

	// function called to save edited data
	const handleEditSaveClick = (data) => {
		if (editMarketSectorName === '') {
			toast.error("MarketSector name cannot be empty.");
		} else {
			submitMarketSectorEdit({
				"data": {
					"MarketSectorId": data.marketSectorId,
					"MarketSectorName": editMarketSectorName,
				},
				"token": auth[0].token
			});
			setEditMarketSectorId('');
			setEditMarketSectorName('');
		}
	}

	if (!isAuthenticated) return <Navigate to="/login" />;

	return (
		<MainWrapper>
			<Loader loading={isLoading}>
				<div className="container">

					<div className="sub-header mt-5 mb-3">
						<h2>MarketSector</h2>
						<Link className="btn btn-primary me-1" to="/admin"><Icon icon={ic_arrow_back} />Back to Value List</Link>
						<Create
							variant="primary"
							title={`MarketSector`}
							createModalOpen={createModalOpen}
							showCreateModal={showCreateModal}
							hideCreateModal={hideCreateModal}
							inputVal={inputVal}
							handleCreateModalChange={handleCreateModalChange}
							handleCreateModalSubmit={handleCreateModalSubmit}
						/>
					</div>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>MarketSector</th>
								<th width="50">Delete</th>
							</tr>
						</thead>
						<tbody>
							{valueList && valueList.length > 0 ? (
								valueList.map((item, index) => (
									<tr key={index}>
										{editMarketSectorId === item.marketSectorId ? (
											<td>
												<Form.Group>
													<InputGroup>
														<Form.Control type="text" value={editMarketSectorName} onChange={(evt) => setEditMarketSectorName(evt.target.value)} />
														<Button variant="outline-secondary">
															<Icon size={24} icon={ic_save} onClick={() => handleEditSaveClick(item)} />
														</Button>
													</InputGroup>
												</Form.Group>
											</td>
										) : (
											<td>
												{item.marketSectorName}
												<Icon role="button" className="float-end" size={24} icon={ic_mode_edit} onClick={() => handleEditClick(item)} />
											</td>
										)}
										<td>
											<ConfirmDelete variant="primary" title={`MarketSector`} showConfirmDeleteModal={() => showConfirmDeleteModal(item.marketSectorId)} hideConfirmDeleteModal={hideConfirmDeleteModal} handleConfirmDeleteSubmit={handleConfirmDeleteSubmit} confirmDeleteModal={confirmDeleteModal} />
										</td>
									</tr>
								))
							) : (
								<tr>
									<td colSpan={2}>
										No Data Found.
									</td>
								</tr>
							)}
						</tbody>
					</Table>
				</div>
			</Loader>
		</MainWrapper>
	);
}

const mapStateToProps = ({ auth, valueList }) => {
	return {
		auth,
		valueList
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		fetchMarketSector: (token) => dispatch({ type: MARKET_SECTOR_REQUEST, token }),
		submitMarketSectorCreate: (data) => dispatch({ type: MARKET_SECTOR_CREATE, payload: data }),
		submitMarketSectorDelete: (data) => dispatch({ type: MARKET_SECTOR_DELETE, payload: data }),
		submitMarketSectorEdit: (data) => dispatch({ type: MARKET_SECTOR_EDIT, payload: data }),
		changeReducerState: () => dispatch({ type: MARKET_SECTOR_STATE_CHANGE })
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(MarketSector);